<template>
  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Notes</h2>
      </div>
      <div class="col">
        <paginate
          :page-count="num_pages"
          :initial-page="paginate.current_page-1"
          :page-range="1"
          :margin-pages="1"
          :click-handler="paginateClick"
          container-class="pagination"
          page-class="page-item"
          page-link-class="page-link"
          prev-class="page-item"
          prev-link-class="page-link"
          next-class="page-item"
          next-link-class="page-link"
        ></paginate>
      </div>
    </div>
    <div class="row table-head" >
      <div class="col">Note</div>
    </div>

    <div class="row lined">

      <div class="col" v-show="!showAddNote">
        <button class="btn btn-primary" @click="setAddNote " ><i class="fa fa-plus"></i> &nbsp;Add Note</button>
      </div>

      <div class="col" v-show="showAddNote">
        <textarea class="form-control" rows="3" v-model="newNote.note" ref="noteField"></textarea>
        <br />
        <button class="btn btn-clear" @click="showAddNote = false;" >Cancel
          </button>
        <button class="btn btn-primary" @click.prevent="addNote" >
          <i class="fa fa-plus"></i> &nbsp;Save Note</button>
        <br />
        <br />
      </div>
    </div>

    <div class="row lined" v-for="n, i in accountNotes" :key="n.accountNote_id">
      <div class="col-3" v-show="!selected || selected.accountNote_id != n.accountNote_id">
        {{n.timestamp | formatDate}}
      </div>
      <div class="col-3" v-show="!selected || selected.accountNote_id != n.accountNote_id">
        {{n.user_name}}
      </div>
      <div class="col-4" v-show="!selected || selected.accountNote_id != n.accountNote_id">
        {{n.note}}
      </div>
      <div class="col-2 text-right">
        <dropdown-confirmation
          title="Are you sure you want to delete this note?"
          @confirm="deleteNote(n)"></dropdown-confirmation>
        </div>
      </div>

  </div>
</template>
<script type="text/babel">
  var Paginate = require('vuejs-paginate');
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  export default {
    name: 'Notes',
    data: function(){
      return {
        params: {
          data: {
            account_id: ''
          }
        },
        newNote: {
          note:''
        },
        num_pages: 0,
        paginate:{
          current_page: 1,
          limit: 5,
          offset:0
        },
        selected: {
          accountNote_id: '',
          user_id: '',
          user_name: '',
          timestamp: '',
          note: ''
        },
        showAddNote: false,
        accountNotes:[]

      }
    },
    components:{
      Paginate,
      DropdownConfirmation,
    },
    created(){

      this.fetchAccountNotes();
    },
    computed:{},
    filters:{
      formatDate(date){
        return moment(date).format('MM/DD/YYYY hh:mm:ss a');
      }
    },
    methods:{
      setAddNote(){
        this.showAddNote = true;
        this.$nextTick(function(){
            this.$refs.noteField.focus();
        })
    },
    addNote(){
        this.updateNotes(this.newNote);
    },
      updateNotes(note){
        var _this = this;
        var data = note;
        data.account_id = this.account_id;
        var fn = (data.accountNote_id)? 'accountNoteUpdate': 'accountNoteCreate';

        this.$send(this, fn, data).then(r => {
          this.fetchAccountNotes();
          this.newNote.note = '';
        });

      /*
        this.$http.post('http://10.0.24.14/api.php', {
          function: fn,
          data: data
        }, {
          emulateJSON: true
        }).then(function(response){
          if(response.body.status){
            _this.fetchAccountNotes();
            this.newNote.note = '';
          } else {
            this.$store.commit('setStatus', {
              status: false,
              message:response.body.message
            });
          }
        });
        */
      },
      deleteNote(selected){



        this.$send(this, 'accountNoteDelete', selected).then(r => {
          this.fetchAccountNotes();
        });

/*
        this.$http.post('http://10.0.24.14/api.php', {
          function: 'accountNoteDelete',
          data: selected
        }, {
          emulateJSON: true
        }).then(function(response){
          if(response.body.status){
            _this.fetchAccountNotes();
            this.newNote.note = '';
          } else {
            this.$store.commit('setStatus', {
              status: false,
              message:response.body.message
            });
          }
        });
        */
      },
      paginateClick(pageNum){
        this.paginate.current_page = pageNum;
        this.fetchAccountNotes();
      },
      fetchAccountNotes(){
        var data = {};
        data.account_id = this.account_id;
        data.offset = this.paginate.limit * (this.paginate.current_page - 1);
        data.limit = this.paginate.limit;

        // this.timer = moment().valueOf();
        // data.time = this.timer;
        this.$send(this, 'accountNotes', data).then(r => {
          this.accountNotes = r.accountNotes;
          this.num_pages = Math.ceil(r.count / this.paginate.limit);
        });

      },
    },
    props:{
      details: {
        type: Object
      },
      account_id:{

      }

    }

  }

</script>




// WEBPACK FOOTER //
// AccountNotes.vue?1cba821c